import React, { memo, Component } from 'react';
import { motion } from 'framer-motion';
import { BriefcaseIcon, CoffeeIcon, GiftIcon, UtensilsIcon } from 'lucide-react';
export function Catering() {
  const services = [{
    icon: UtensilsIcon,
    title: 'Bandejas Corporativas',
    description: 'Selección premium para reuniones y eventos empresariales',
    image: 'https://images.unsplash.com/photo-1555939594-58d7cb561ad1?w=600&q=80'
  }, {
    icon: CoffeeIcon,
    title: 'Desayunos Empresariales',
    description: 'Comienza el día con calidad y sabor',
    image: 'https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=600&q=80'
  }, {
    icon: GiftIcon,
    title: 'Boxes Personalizados',
    description: 'Regalos corporativos únicos y memorables',
    image: 'https://cdn.magicpatterns.com/uploads/x4ZqEDkxkqyRLF74XhXkRj/Hitube_1f3F9GnjJz_2026_05_13_01_08_30.jpg'
  }, {
    icon: BriefcaseIcon,
    title: 'Catering Premium',
    description: 'Servicio completo para eventos corporativos',
    image: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=600&q=80'
  }];
  const handleWhatsApp = () => {
    const message = encodeURIComponent('Hola! Quiero consultar por servicios de catering y regalos empresariales.');
    window.open(`https://wa.me/5492665013601?text=${message}`, '_blank');
  };
  return <section id="catering" className="py-20 bg-white" data-id="element-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-11">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-12">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-secondary-brown mb-4" data-id="element-13">
            Catering y Regalos Empresariales
          </h2>
          <p className="text-lg text-secondary-brown-light max-w-2xl mx-auto" data-id="element-14">
            Soluciones premium para empresas que buscan calidad y excelencia
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-15">
          {services.map((service, index) => <motion.div key={service.title} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-secondary-cream rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow group" data-id="element-16">
              <div className="relative h-64 overflow-hidden" data-id="element-17">
                <img src={service.image} alt={service.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" data-id="element-18" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" data-id="element-19" />
                <div className="absolute top-6 left-6" data-id="element-20">
                  <div className="bg-primary-yellow p-3 rounded-full" data-id="element-21">
                    <service.icon className="text-secondary-brown" size={24} data-id="element-22" />
                  </div>
                </div>
              </div>
              <div className="p-8" data-id="element-23">
                <h3 className="text-2xl font-serif font-semibold text-secondary-brown mb-3" data-id="element-24">
                  {service.title}
                </h3>
                <p className="text-secondary-brown-light" data-id="element-25">
                  {service.description}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-26">
          <button onClick={handleWhatsApp} className="bg-primary-yellow text-secondary-brown px-10 py-4 rounded-full font-semibold text-lg hover:bg-primary-gold transition-all transform hover:scale-105 shadow-lg" data-id="element-27">
            Solicitar Cotización
          </button>
        </motion.div>
      </div>
    </section>;
}